import { render, staticRenderFns } from "./Microphone.vue?vue&type=template&id=b7bdb00a&scoped=true"
import script from "./Microphone.vue?vue&type=script&lang=js"
export * from "./Microphone.vue?vue&type=script&lang=js"
import style0 from "./Microphone.vue?vue&type=style&index=0&id=b7bdb00a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bdb00a",
  null
  
)

export default component.exports